export default __webpack_public_path__ + "static/media/icon-menu-job-active.a073daab.svg";